import {makePostRequest, makeGetRequest} from '@/js/global/helpers/requests';

/**
 * AJAX MIXIN
 *
 * Helpful methods and properties for making AJAX requests
 */
export const AjaxMixin = {
    methods: {

        /**
         * Make a POST request to any Yii controller action URL.
         *
         * @param action {string}
         * @param data {object}
         * @param config {object}
         * @param rerun {boolean}
         * @return {AxiosResponse<any>|*>}
         */
        async makePostRequest(action, data = {}, config = {}, rerun = true) {
            return await makePostRequest(action, data, config, rerun);
        },

        /**
         * Make a GET request to any Yii controller action URL.
         *
         * @param action {string}
         * @param config {object}
         * @param acceptsJson {boolean}
         * @return {Promise<AxiosResponse<any>|*>}
         */
        async makeGetRequest(action, config = {}, acceptsJson = false) {
            return await makeGetRequest(action, config, acceptsJson);
        },

        /**
         * Run VeeValidate's validation and handle the success or erroneous outcomes.
         *
         * @param observerRef
         * @param callback
         * @returns {Promise<void>}
         */
        async onValidate(observerRef, callback) {
            // if observerRef is not a string, default to 'observer' as the name of the ref
            if (typeof observerRef !== 'string') {
                observerRef = 'observer';
            }

            // get the form observer element
            const form = this.$refs[observerRef];
            if (! form) {
                return;
            }

            // validate the form and scroll to first error if errors exist
            const isValid = await form.validate();
            if (! isValid) {
                setTimeout(() => {
                    const errors = Object.entries(form.errors)
                        .map(([key, value]) => ({key, value}))
                        .filter(error => error['value'].length);

                    const firstErrorElement = form.refs[errors[0]['key']].$el;
                    this.$scrollTo(firstErrorElement);
                }, 100);

                return;
            }

            // run the callback function to submit the form
            if (typeof callback === 'function') {
                callback();
            }
            else {
                // this assumes an `onSubmit()` method exists in the Vue instance or component
                this.onSubmit();
            }
        },
    }
}